// Phone Format
export const phoneFlatFormat = (phone) => {
  return phone.replace(new RegExp(/[ , (),+]/, "gm"), "");
};

export const isValidTurkishPhoneNumber = (phoneNumber) => {
  const regex = /^\+90\s\(5\d{2}\)\s\d{3}\s\d{2}\s\d{2}$/;
  return regex.test(phoneNumber);
};
